import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import * as styles from './themeLogo.module.css'

const ThemeLogo = () => {
  const { allContentfulActiveTheme } = useStaticQuery(graphql`
    query {
      allContentfulActiveTheme {
        edges {
          node {
            theme {
              logo {
                file {
                  url
                }
              }
            }
          }
        }
      }
    }
  `)

  const logoUrl = allContentfulActiveTheme.edges[0].node.theme.logo.file.url

  return (
    <img className={styles.themeLogo} src={logoUrl} alt="Synapse Studios" />
  )
}

export default ThemeLogo
